/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DomainMappingDto } from './DomainMappingDto';
import {
    DomainMappingDtoFromJSON,
    DomainMappingDtoFromJSONTyped,
    DomainMappingDtoToJSON,
    DomainMappingDtoToJSONTyped,
} from './DomainMappingDto';

/**
 * 
 * @export
 * @interface DomainMappingResponse
 */
export interface DomainMappingResponse {
    /**
     * 
     * @type {DomainMappingDto}
     * @memberof DomainMappingResponse
     */
    data?: DomainMappingDto;
    /**
     * Indicates if the request was successful
     * @type {boolean}
     * @memberof DomainMappingResponse
     */
    success?: boolean;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof DomainMappingResponse
     */
    error?: string;
}

/**
 * Check if a given object implements the DomainMappingResponse interface.
 */
export function instanceOfDomainMappingResponse(value: object): value is DomainMappingResponse {
    return true;
}

export function DomainMappingResponseFromJSON(json: any): DomainMappingResponse {
    return DomainMappingResponseFromJSONTyped(json, false);
}

export function DomainMappingResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DomainMappingResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : DomainMappingDtoFromJSON(json['data']),
        'success': json['success'] == null ? undefined : json['success'],
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function DomainMappingResponseToJSON(json: any): DomainMappingResponse {
    return DomainMappingResponseToJSONTyped(json, false);
}

export function DomainMappingResponseToJSONTyped(value?: DomainMappingResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': DomainMappingDtoToJSON(value['data']),
        'success': value['success'],
        'error': value['error'],
    };
}

